import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "short-video"
};
const _hoisted_2 = {
  class: "cont"
};
const _hoisted_3 = ["id"];

const _hoisted_4 = /*#__PURE__*/_createElementVNode("video", {
  class: "video-js videoPlayer"
}, null, -1);

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "text"
};
import { getGlobalProperties } from "@/assets/js/utils.js";
import { ref, nextTick, onBeforeUnmount, onActivated } from "vue";
export default {
  __name: 'shortVideo',

  setup(__props) {
    const {
      videoShortApi
    } = getGlobalProperties().$api;
    const options = ref({
      autoplay: true,
      muted: false,
      preload: "auto",
      // 预加载
      controls: false,
      poster: "",
      url: "",
      type: "application/x-mpegURL"
    });
    const videoList = ref([]);
    let player = null;

    const createVideo = (id, url) => {
      document.getElementById("videoBox" + id).innerHTML = `<video id="videoPlayer_${id}" class="video-js videoPlayer"></video>`;
      console.log(url);
      const length = url.indexOf("sign=");
      url = url.slice(0, length + 5) + url.slice(length + 15);

      if (player) {
        player.dispose();
      }

      options.value.src = url;
      player = videojs("videoPlayer_" + id, options.value); //关键代码， 动态设置src，才可实现换台操作

      player.src([{
        src: url,
        type: url.indexOf(".m3u8") > -1 ? "application/x-mpegURL" : "video/mp4"
      }]);
    };

    const getData = () => {
      videoShortApi("", "get").then(res => {
        if (res.code === 0) {
          videoList.value = res.data; // videoList.value = res.data.map((item) => {
          //   item.url = item.url.slice(0, 5) + "://" + item.url.slice(8);
          //   return item;
          // });

          nextTick(() => {
            createVideo(videoList.value[0].id, videoList.value[0].url);
          });
        }
      });
    };

    getData();

    const change = index => {
      console.log(index);
      nextTick(() => {
        createVideo(videoList.value[index].id, videoList.value[index].url);
      });
    };

    onActivated(() => {
      getData();
    });
    onBeforeUnmount(() => {
      if (player) {
        player.pause();
      }
    });
    return (_ctx, _cache) => {
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");

      const _component_van_swipe = _resolveComponent("van-swipe");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_swipe, {
        vertical: "",
        onChange: change,
        "show-indicators": false,
        loop: false
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, item => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
              class: "videoBox",
              id: 'videoBox' + item.id
            }, _hoisted_5, 8, _hoisted_3), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]);
    };
  }

};